import { useSelector } from 'react-redux';
import { EChartsOption } from 'echarts';
import PieChart from 'lib/Charts/PieChart';
import { formatNumber, formatPercent } from 'modules/I18N';
import EmptyPieChart from 'components/common/HeroCharts/EmptyPieChart';
import { getLocaleCode } from 'store/publisher/selectors';
import { ImpressionsRendererProps } from './ImpressionsRenderer.types';

const ImpressionsRenderer: React.FC<ImpressionsRendererProps> = ({ value, data, onClick }) => {
  const localeCode = useSelector(getLocaleCode);
  const onPieChartClick = (): void => {
    if (data) {
      onClick(data);
    }
  };

  if (!value?.sold && !value?.reserved) {
    return <EmptyPieChart onChartClick={onPieChartClick} />;
  }

  const chartOptions: EChartsOption = {
    backgroundColor: 'transparent',
    series: [
      {
        type: 'pie',
        emphasis: {
          disabled: true,
        },
      },
    ],
  };

  const chartData: { name: string; value: number }[] = [
    {
      name: 'Reserved',
      value: value.reserved,
    },
    {
      name: 'Sold',
      value: value.sold,
    },
  ];

  return (
    <div className="relative flex flex-row justify-center">
      <PieChart
        colors={['#f8bc1a', '#8066b5']}
        data={chartData}
        options={chartOptions}
        hasDataLabel={false}
        hasEnabledExporting={false}
        hasTooltip={false}
        onClick={onPieChartClick}
        dataTestId="ImpressionsRenderer-pieChart"
        chartHeight="60px"
        chartWidth="60px"
        chartSize="70%"
      />
      <div className="relative w-52 flex flex-col justify-center mr-6">
        <div className="mb-1">
          <span className="inline-block h-2.5 w-2.5 mx-1 mt-1 bg-yellow" />
          {formatNumber({ value: value.reserved, localeCode })}&nbsp;{chartData[0].name}
        </div>
        <div>
          <span className="inline-block h-2.5 w-2.5 mx-1 mt-1 bg-purple-600" />
          {formatNumber({ value: value.sold, localeCode })}&nbsp;{chartData[1].name}
        </div>
      </div>
      <div className="relative w-40 flex flex-col justify-center border-l border-neutral-300 px-1.5 my-1 ">
        <div>
          {formatPercent({ value: value.pacing, localeCode })}
          &nbsp;Pacing
        </div>
      </div>
    </div>
  );
};

export default ImpressionsRenderer;
